'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var shouldShowLive = exports.shouldShowLive = function shouldShowLive(catalogStatus, isCatalogOnly, saleStartTs) {
    var now = new Date();
    var secondsUntilStart = saleStartTs - now.getTime() / 1000;
    return !isCatalogOnly && (catalogStatus === 'live' || catalogStatus === 'online' && secondsUntilStart < 60 * 10);
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/live.js
// module id = o2ZH
// module chunks = 57